/* KYME ACTIVE â€” product page behaviour */
(function () {
  'use strict';

  var root = document.querySelector('[data-kyme-product]');
  if (!root) return;

  var sizesWrap = root.querySelector('[data-kyme-sizes]');
  var sizeLabel = root.querySelector('[data-kyme-size-label]');
  var priceEl = root.querySelector('[data-kyme-price]');
  var addBtns = document.querySelectorAll('[data-kyme-add]');
  var addText = root.querySelector('[data-kyme-add-text]');
  var sticky = document.querySelector('[data-kyme-sticky]');
  var stickySize = document.querySelector('[data-kyme-sticky-size]');
  var mainAdd = root.querySelector('.kp__add');

  var state = {
    id: mainAdd ? mainAdd.getAttribute('data-variant-id') : null,
    size: sizeLabel ? sizeLabel.textContent.trim() : '',
    price: priceEl ? priceEl.textContent.trim() : ''
  };

  /* ---------- size selection ---------- */

  if (sizesWrap) {
    sizesWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.kp__size');
      if (!btn || btn.disabled) return;

      sizesWrap.querySelectorAll('.kp__size').forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-checked', 'true');

      state.id = btn.getAttribute('data-variant-id');
      state.size = btn.textContent.trim();
      state.price = btn.getAttribute('data-price') || state.price;

      if (sizeLabel) sizeLabel.textContent = state.size;
      if (stickySize) stickySize.textContent = state.size;
      if (priceEl) priceEl.textContent = state.price;
      if (addText) addText.textContent = 'Add to bag - ' + state.price.replace(/\.00$/, '');

      addBtns.forEach(function (b) { b.setAttribute('data-variant-id', state.id); });
      history.replaceState({}, '', updateParam(location.href, 'variant', state.id));
    });
  }

  function updateParam(url, key, value) {
    var u = new URL(url);
    u.searchParams.set(key, value);
    return u.toString();
  }

  /* ---------- add to bag ---------- */

  addBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-variant-id') || state.id;
      if (!id) return;
      add(btn, id, root.querySelector('.kp__title').textContent.trim());
    });
  });

  /* ---------- complete the look: inline size picker ---------- */

  var lookToggles = document.querySelectorAll('[data-kyme-look-toggle]');

  function closeLookPickers(except) {
    lookToggles.forEach(function (toggle) {
      if (toggle === except) return;
      var card = toggle.closest('.kp__look-card');
      var panel = card && card.querySelector('[data-kyme-look-sizes]');
      toggle.setAttribute('aria-expanded', 'false');
      if (panel) panel.setAttribute('hidden', '');
    });
  }

  lookToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var card = toggle.closest('.kp__look-card');
      var panel = card && card.querySelector('[data-kyme-look-sizes]');
      if (!panel) return;
      var isOpen = !panel.hasAttribute('hidden');
      closeLookPickers(toggle);
      if (isOpen) {
        panel.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        panel.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.querySelectorAll('.kp__look-size').forEach(function (sizeBtn) {
    sizeBtn.addEventListener('click', function () {
      if (sizeBtn.disabled) return;
      var card = sizeBtn.closest('.kp__look-card');
      var panel = card && card.querySelector('[data-kyme-look-sizes]');
      var toggle = card && card.querySelector('[data-kyme-look-toggle]');
      add(sizeBtn, sizeBtn.getAttribute('data-variant-id'), sizeBtn.getAttribute('data-title') || 'Item');
      if (panel) panel.setAttribute('hidden', '');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  });

  /* ---------- size guide drawer ---------- */

  var sizeGuideOpenBtns = document.querySelectorAll('[data-kyme-sizeguide-open]');
  var sizeGuide = document.querySelector('[data-kyme-sizeguide]');

  if (sizeGuide && sizeGuideOpenBtns.length) {
    var sgBody = sizeGuide.querySelector('[data-kyme-sizeguide-body]');
    var sgMeasure = sizeGuide.querySelector('[data-kyme-sizeguide-measure]');
    var sgUnitBtns = sizeGuide.querySelectorAll('[data-kyme-sizeguide-unit]');
    var sgCloseEls = sizeGuide.querySelectorAll('[data-kyme-sizeguide-close]');
    var sgUnit = 'cm';
    var sgChart = null;
    var sgScrollY = 0;

    var sgConvert = function (v) {
      if (typeof v !== 'number') return v;
      return sgUnit === 'cm' ? v : Math.round((v / 2.54) * 10) / 10;
    };

    var sgRenderTables = function () {
      if (!sgChart) {
        sgBody.innerHTML = '<p class="kp-sizeguide__none">Full measurements for this style are coming soon. In the meantime, use the size you normally wear in activewear as a guide.</p>';
        return;
      }
      var html = '';
      sgChart.tables.forEach(function (t) {
        if (t.label) html += '<p class="kp-sizeguide__tlabel">' + t.label + '</p>';
        html += '<div class="kp-sizeguide__scroll"><table class="kp-sizeguide__table"><thead><tr>';
        t.columns.forEach(function (c, i) {
          html += '<th>' + c + (i > 0 ? ' (' + (sgUnit === 'cm' ? 'cm' : 'in') + ')' : '') + '</th>';
        });
        html += '</tr></thead><tbody>';
        t.rows.forEach(function (row) {
          html += '<tr>';
          row.forEach(function (v, i) {
            html += '<td>' + (i === 0 ? v : sgConvert(v)) + '</td>';
          });
          html += '</tr>';
        });
        html += '</tbody></table></div>';
      });
      sgBody.innerHTML = html;
    };

    var sgRenderMeasure = function () {
      var data = window.KymeSizeGuide;
      if (!data) { sgMeasure.innerHTML = ''; return; }
      var cols = sgChart ? sgChart.tables[0].columns.slice(1) : [];
      var terms = data.howToMeasure.filter(function (h) {
        return cols.some(function (c) { return c.toLowerCase().indexOf(h.term.toLowerCase()) !== -1; });
      });
      if (terms.length === 0) terms = data.howToMeasure.slice(0, 4);
      var html = '';
      terms.forEach(function (h) {
        html += '<div><h4>' + h.term + '</h4><p>' + h.detail + '</p></div>';
      });
      sgMeasure.innerHTML = html;
    };

    var openSizeGuide = function (styleName) {
      var data = window.KymeSizeGuide;
      sgChart = data ? data.getChartForStyle(styleName) : null;
      sgRenderTables();
      sgRenderMeasure();
      sgScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + sgScrollY + 'px';
      document.body.style.width = '100%';
      sizeGuide.removeAttribute('hidden');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { sizeGuide.classList.add('is-open'); });
      });
    };

    var closeSizeGuide = function () {
      sizeGuide.classList.remove('is-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, sgScrollY);
      window.setTimeout(function () { sizeGuide.setAttribute('hidden', ''); }, 320);
    };

    sizeGuideOpenBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        openSizeGuide(btn.getAttribute('data-style-name'));
      });
    });

    sgCloseEls.forEach(function (el) {
      el.addEventListener('click', closeSizeGuide);
    });

    sgUnitBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sgUnit = btn.getAttribute('data-kyme-sizeguide-unit');
        sgUnitBtns.forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        sgRenderTables();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sizeGuide.hasAttribute('hidden')) closeSizeGuide();
    });
  }

  function add(button, variantId, title) {
    var label = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...'

    var base = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var cartDrawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(variantId), quantity: 1 }] };

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      body.sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (response) {
        var rendered = false;
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          try {
            cartDrawer.renderContents(response);
            rendered = true;
          } catch (err) {
            console.error('[kyme] cart-drawer renderContents failed; item was added to cart.', err);
          }
        }
        if (!rendered) toast('Added - ' + title);
        refreshCartCount();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      })
      .catch(function (err) {
        console.error('[kyme] add to cart failed', err);
        toast('Could not add that. Refresh and try again.');
      })
      .finally(function () {
        button.disabled = false;
        button.textContent = label;
      });
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document
          .querySelectorAll('[data-cart-count], .cart-count, .site-header__cart-count, .cart-link__bubble-num, #CartCount')
          .forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.remove('hide', 'hidden');
          });
      })
      .catch(function () {});
  }

  var toastTimer;
  function toast(message) {
    var el = document.querySelector('[data-kyme-toast]');
    if (!el) return;
    el.querySelector('[data-kyme-toast-text]').textContent = message;
    el.removeAttribute('hidden');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.setAttribute('hidden', ''); }, 4000);
  }

  /* ---------- sticky bar: show once the main button scrolls away ---------- */

  if (sticky && mainAdd && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sticky.setAttribute('hidden', '');
          } else if (entry.boundingClientRect.top < 0) {
            sticky.removeAttribute('hidden');
          } else {
            sticky.setAttribute('hidden', '');
          }
        });
      },
      { threshold: 0 }
    ).observe(mainAdd);
  }
})();